enum Theme {
  'Light' = 'LIGHT',
  'Dark' = 'DARK',
}

export default Theme;
